import { GlobalActions, PapersActions } from '@src/types/actions'

import { deletePaper, getPapers, setPapers } from '@src/state/papers/actions'

import { getType } from 'typesafe-actions'
import { resetState } from '../actions'

export interface Paper {
  readonly updatedAt: string
  readonly filename: string
  readonly id: string
}

export interface PaperState {
  papers: Paper[]
  resolved: boolean
  deleting: boolean
}

const initialState: PaperState = {
  papers: [],
  resolved: false,
  deleting: false,
}

const papersReducer = (
  state: PaperState = initialState,
  action: PapersActions | GlobalActions
) => {
  switch (action.type) {
    case getType(setPapers): {
      return {
        ...state,
        papers: action.payload.papers,
        resolved: true,
      }
    }
    case getType(getPapers): {
      return initialState
    }

    case getType(deletePaper.request): {
      return {
        ...state,
        deleting: true,
      }
    }
    case getType(deletePaper.failure):
    case getType(deletePaper.success): {
      return {
        ...state,
        deleting: false,
      }
    }
    case getType(resetState): {
      return initialState
    }
    default:
      return state
  }
}

export default papersReducer



// WEBPACK FOOTER //
// ./src/state/papers/reducer.ts